<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle title="CAPS" description="" url="/dashboard" />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <div
                class="ribbon"
                v-if="item.featured !== undefined && item.featured == true"
              >
                <span>BETA</span>
              </div>
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ExportarRaas from '@/components/icons/BpaRaas/ExportarRaas.vue'
import ImportarRaas from '@/components/icons/BpaRaas/ImportarRaas.vue'

export default {
  name: 'Caps',
  metaInfo: {
    title: 'CAPS',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ExportarRaas,
    ImportarRaas,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.caps
      ) {
        const bpaErasClone = [...this.$store.state.permissoes.caps]
        return bpaErasClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
